import { map, uniqBy, every, join } from 'lodash'

export function* getParallelResponse(res) {
  const mapResponse = yield map(res)
  const responseOk = yield every(mapResponse, 'ok')
  const responseJson = yield map(mapResponse, r => r.json())
  const uniqResponse = yield uniqBy(responseJson, 'message')

  const errorMessages = yield join(map(uniqResponse, 'message'), ',')

  return {
    ok: responseOk,
    data: mapResponse,
    error: {
      message: errorMessages,
    },
  }
}
